import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Workflow } from 'src/app/components/designer/models/workflow';
import { WorkflowUpdateResult } from 'src/app/components/designer/models/workflow-update-result';
import { CrudService } from '../crud-service';
import { MemoryService } from '../memory.service';

@Injectable({
    providedIn: 'root',
})
export class WorkflowDefinitionsService extends CrudService {
    constructor(
        private http: HttpClient,
        public override memoryService: MemoryService
    ) {
        super(memoryService);
    }

    update(viewId: number, workflow: Workflow): Observable<WorkflowUpdateResult> {
        // Appel de la Web Api
        return this.http
            .put<WorkflowUpdateResult>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/workflow`, workflow, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    var res = WorkflowUpdateResult.clone(x);
                    return res;
                })
            );
    }

    activate(viewId: number): Observable<WorkflowUpdateResult> {
        // Appel de la Web Api
        return this.http
            .patch<WorkflowUpdateResult>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/workflow/activate`, null, this.getDefaultHttpOptions())
            .pipe(
                map((x) => {
                    var res = WorkflowUpdateResult.clone(x);
                    return res;
                })
            );
    }

    get(viewId: number): Observable<Workflow> {
        // Appel de la Web Api
        return this.http.get<Workflow>(this.baseUrl + `/api/organizations/${this.organizationId}/views/${viewId}/workflow`, this.getDefaultHttpOptions()).pipe(
            map((x) => {
                var res = Workflow.clone(x);
                return res;
            })
        );
    }
}
